/** @format */

import React, { ChangeEvent, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import useSystemLanguage from '../../../modules/language/hooks/useSystemLanguage';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';
import { REQUEST_STATE } from '../../../helpers/RequestHelper';
import { PlatformResellerSendType } from '../PlatformResellerModify';
import CustomMultiSelect from '../../../components/Form/CustomMultiSelect';
import useResellerAvailableSystemLanguages from '../../../modules/language/hooks/useResellerAvailableSystemLanguages';

interface PlatformResellerInvoiceLanguagePropsInterface {
    platformResellerId: string | null | undefined;
    platformReseller: PlatformResellerInterface | PlatformResellerSendType;
    changeInvoiceLanguageCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PlatformResellerInvoiceLanguage: React.FC<PlatformResellerInvoiceLanguagePropsInterface> = (props) => {
    const { platformReseller, changeInvoiceLanguageCallback, platformResellerId } = props;

    const resId = platformResellerId ? platformResellerId.split('/')[platformResellerId.split('/').length - 1] : null;

    const { state: systemLanguageState, systemLanguageCollection } = useSystemLanguage();

    if (!systemLanguageCollection) {
        return null;
    }

    if (systemLanguageState !== REQUEST_STATE.IDLE) {
        return null;
    }

    return (
        <SimpleSelect
            label={'platform_reseller:pr.reseller_invoice_language'}
            required={true}
            elements={systemLanguageCollection['hydra:member'].map((el) => {
                return { name: `general:language.${el.language}`, value: el.id ?? -1 };
            })}
            dispatchName={'layout'}
            fieldName={'layout'}
            selectedValue={platformReseller.invoiceLanguageId}
            callback={changeInvoiceLanguageCallback}
        />
    );
};

export default PlatformResellerInvoiceLanguage;
